module.exports = __webpack_public_path__ + "static/media/StepBoxSquare.e6e10b21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/StepBoxSquare.svg
// module id = 504
// module chunks = 0